import PercentDollarToggle from './PercentDollarToggle'
import { DerivedValueBox, EditableValueBox } from './ValueBox'

// The toggle is a `control` (sits beside the label, FieldRow.jsx), never a `children` value box --
// see README.md ("control belongs beside the label"). A distinct aria-label from the input below it
// avoids `getByLabelText` ambiguity, since a radiogroup's and an input's aria-label are both valid
// accessible names for the same text.
export function PercentDollarToggleControl({ toggleValue, onToggleChange, ariaLabel }) {
  const isDollarMode = toggleValue === '$'
  return (
    <PercentDollarToggle
      mode={isDollarMode ? 'dollar' : 'percent'}
      onChange={(mode) => onToggleChange(mode === 'dollar' ? '$' : '%')}
      ariaLabel={`${ariaLabel} toggle`}
    />
  )
}

// The value-box half of the repeated "editable percent, derived-or-overridden dollar" pair (spec
// 1.3); renders as FieldRow's `children`. Rehab Financing % uses this with no toggle at all --
// `toggleValue` stays undefined, which resolves to percent mode the same as any unset toggle.
// Dollar-box editability: see README.md ("the toggle sentinel").
export default function PercentDollarRow({
  percentValue,
  onPercentChange,
  percentAriaLabel,
  dollarValue,
  onDollarChange,
  dollarAriaLabel,
  dollarComputedValue = null,
  toggleValue,
}) {
  const isDollarMode = toggleValue === '$'

  // Letter 99 (7 Toggles 2): in $ mode the % box and its separator are gone "for a cleaner look"; the
  // $ box stays where it was, flush right in FieldRow's value column. The keys stop React handing the
  // % box's typed draft to the $ box, both being the first child. README.md ("$ mode hides the % box").
  if (isDollarMode) {
    return <EditableValueBox money key="dollar" value={dollarValue} onChange={onDollarChange} width={88} ariaLabel={dollarAriaLabel} />
  }

  return (
    <>
      <EditableValueBox key="percent" value={percentValue} onChange={onPercentChange} width={72} suffix="%" ariaLabel={percentAriaLabel} />
      <span className="w-px h-[16px] bg-brand-fieldBdr shrink-0" aria-hidden="true" />
      <DerivedValueBox value={dollarComputedValue} width={88} ariaLabel={dollarAriaLabel} />
    </>
  )
}
